import angular from 'angular';
import _ from "lodash";

(function () {
    'use strict';
    angular.module('app.core').factory('RoutingCodeDA', RoutingCodeDA);

    RoutingCodeDA.$inject = ['Restangular', 'CONF', '$translate', 'RoutingCode'];

    /**
     * Classe permettant la manipulation des infos relatives aux codes routage.
     */

    /* @ngInject */
    function RoutingCodeDA(Restangular, CONF, $translate, RoutingCode) {
        var baseUrl = CONF.apiBaseUrl + '/v1/routing-code';

        var exports = {
            getRoutingCodes: getRoutingCodes,
            createUpdateRouting: createUpdateRouting,
            getRoutingCodeDetails: getRoutingCodeDetails
        };

        return exports;
        
        /**
         * Récupère les codes routage de la sous-entité.
         * @param subEntityId - l'identifiant de la sous-entitée à laquelle les codes routage sont rattachés.
         */
         function getRoutingCodes(subEntityId) {
            return Restangular.one(baseUrl + '/' + subEntityId)
                .get()
                .then(function (routingCodes) {
                    return _.map(routingCodes, function (se) {
                        return new RoutingCode(se, $translate);
                    });
                });
        }


        /**
         * Création/Modififcation d'un code routage.
         */
        function createUpdateRouting(subEntityId, routingCode) {
            return Restangular.one(baseUrl, subEntityId).customPOST(routingCode);
        }

        /**
         * Récupère les détails d'un code routage.
         */
        function getRoutingCodeDetails(routingCodeId){
            return Restangular.one(baseUrl + '/' + routingCodeId + '/details')
                .get()
                .then(function (data) {
                    return new RoutingCode(data, $translate);
                });
        }
    }
})();
